function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#product-3_svg__filter0_f)"
}, React.createElement("path", {
  d: "M263.228 631.659c3.63-22.57-15.22-72.468-119.658-91.503-130.549-23.793 45.841-60.841 164.51-118.899 84.394-41.289 83.631-73.091 36.191-69.582-119.397 8.834-223.55 51.585-266.07 35.616-27.72-10.411 170.661-100.239 236.256-116.243 65.594-16.004-103.903-71.96-233.452-17.772-103.64 43.35 212.242-139.953 220.089-162.835 11.759-34.29-342.935 36.842-285.401-10.743C87.611 20.218 268.35 13.216 277.604 9.346",
  stroke: "#D5D4D4",
  strokeWidth: 2.62
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "product-3_svg__filter0_f",
  x: 0.983,
  y: 0.045,
  width: 398.536,
  height: 650.356,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1.31,
  result: "effect1_foregroundBlur"
})));

var SvgProduct3 = function SvgProduct3(props) {
  return React.createElement("svg", _extends({
    width: 400,
    height: 651,
    viewBox: "0 0 400 651",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjY1MSIgdmlld0JveD0iMCAwIDQwMCA2NTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2YpIj4KPHBhdGggZD0iTTI2My4yMjggNjMxLjY1OUMyNjYuODU4IDYwOS4wODkgMjQ4LjAwOCA1NTkuMTkxIDE0My41NyA1NDAuMTU2QzEzLjAyMTIgNTE2LjM2MyAxODkuNDExIDQ3OS4zMTUgMzA4LjA4IDQyMS4yNTdDMzkyLjQ3NCAzNzkuOTY4IDM5MS43MTEgMzQ4LjE2NiAzNDQuMjcxIDM1MS42NzVDMjI0Ljg3NCAzNjAuNTA5IDEyMC43MjEgNDAzLjI2IDc4LjIwMDYgMzg3LjI5MUM1MC40ODAyIDM3Ni44OCAyNDguODYyIDI4Ny4wNTIgMzE0LjQ1NyAyNzEuMDQ4QzM4MC4wNTEgMjU1LjA0NCAyMTAuNTU0IDE5OS4wODggODEuMDA0OSAyNTMuMjc2Qy0yMi42MzQxIDI5Ni42MjYgMjkzLjI0NyAxMTMuMzIzIDMwMS4wOTQgOTAuNDQxMUMzMTIuODUzIDU2LjE1MSAtNDEuODQxNCAxMjcuMjgzIDE1LjY5MyA3OS42OTgzQzg3LjYxMSAyMC4yMTcxIDI2OC4zNSAxMy4yMTY0IDI3Ny42MDQgOS4zNDU4NiIgc3Ryb2tlPSIjRDVENEQ0IiBzdHJva2Utd2lkdGg9IjIuNjE5NjkiLz4KPC9nPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9mIiB4PSIwLjk4Mjg1MyIgeT0iMC4wNDQ4NjUxIiB3aWR0aD0iMzk4LjUzNiIgaGVpZ2h0PSI2NTAuMzU2IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjEuMzA5ODQiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1ciIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgProduct3 as ReactComponent };